import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M16.457 15.858c-.39.391-1.278.137-1.982-.567s-.958-1.591-.567-1.982 1.28-.138 1.983.566c.704.704.958 1.592.566 1.983Z" fill="currentColor" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> <path d="M14.35 15.208h-2.292a3.333 3.333 0 0 1-3.333-3.333v-1.667m0 0H7.89a3.333 3.333 0 0 1-3.333-3.333V3.958m4.167 6.25h1.25a3.333 3.333 0 0 0 3.333-3.333V3.958" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);